<div class="welcome-container">
  <div class="welcome-card">
    <img *ngIf="logoUrl" [src]="logoUrl" alt="Institution Logo" class="logo" />
    <h1 class="welcome-title">{{ title }}</h1>
    <p class="welcome-message">{{ welcomeMsg }}</p>
  </div>
</div>